import { Component, Input } from '@angular/core';
import { AccountUsageDecisionDto } from '../../models/account-usage.model';
import { LanguageService } from '../../../../services/language/language.service';

@Component({
  selector: 'app-decisions-table',
  templateUrl: './decisions-table.component.html',
  styleUrls: ['./decisions-table.component.scss'],
  standalone: false
})
export class DecisionsTableComponent {
  @Input() decisions: AccountUsageDecisionDto[] | null = null;
  @Input() pageSize = 5;

  page = 0;

  constructor(private readonly languageService: LanguageService) {}

  get sortedDecisions(): AccountUsageDecisionDto[] {
    const list = Array.isArray(this.decisions) ? [...this.decisions] : [];
    return list.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.sortedDecisions.length / this.pageSize));
  }

  get pageItems(): AccountUsageDecisionDto[] {
    const start = this.page * this.pageSize;
    return this.sortedDecisions.slice(start, start + this.pageSize);
  }

  get isEmpty(): boolean {
    return this.sortedDecisions.length === 0;
  }

  prev(): void {
    if (this.page > 0) {
      this.page--;
    }
  }

  next(): void {
    if (this.page < this.totalPages - 1) {
      this.page++;
    }
  }

  translate(key: string): string {
    const translated = this.languageService.translate(key);
    return translated && translated !== key ? translated : key;
  }
}
